import type { CustomJobStatus } from "@/modules/custom-jobs/domain/types";

export type CustomJobStatusBadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "success";

export const CUSTOM_JOB_STATUS_META: Record<
  CustomJobStatus,
  { label: string; variant: CustomJobStatusBadgeVariant; className?: string }
> = {
  pending_confirm: {
    label: "ລໍຖ້າຢືນຢັນ",
    variant: "outline",
  },
  queued: {
    label: "ລໍຖ້າເລີ່ມ",
    variant: "secondary",
  },
  in_progress: {
    label: "ກຳລັງເຮັດ",
    variant: "default",
  },
  ready: {
    label: "ພ້ອມຮັບ",
    variant: "outline",
    className: "border-leaf/40 bg-leaf text-leaf-foreground",
  },
  completed: {
    label: "ສົ່ງມອບແລ້ວ",
    variant: "outline",
    className: "border-leaf/40 bg-leaf/90 text-leaf-foreground",
  },
  cancelled: {
    label: "ຍົກເລີກ",
    variant: "destructive",
  },
};

export const CUSTOM_JOB_LINE_TYPE_LABEL: Record<string, string> = {
  material: "ວັດຖຸດິບ",
  labor: "ຄ່າແຮງ",
  other: "ອື່ນໆ",
};

export const CUSTOM_JOB_LINE_TYPE_BADGE_VARIANT: Record<
  string,
  CustomJobStatusBadgeVariant
> = {
  material: "secondary",
  labor: "default",
  other: "outline",
};

export function customJobStatusLabel(status: CustomJobStatus) {
  return CUSTOM_JOB_STATUS_META[status]?.label ?? status;
}

export function getCustomJobStatusMeta(status: CustomJobStatus) {
  return (
    CUSTOM_JOB_STATUS_META[status] ?? {
      label: status,
      variant: "outline" as const,
    }
  );
}

export function isCustomJobOverdue(
  dueDate: string | null,
  status: CustomJobStatus,
) {
  if (!dueDate) return false;
  if (status === "completed" || status === "cancelled") return false;
  const today = new Date().toISOString().slice(0, 10);
  return dueDate < today;
}
